var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEventMessageWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "events",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_event_message_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.76,52.14H62.24A21.39,21.39,0,0,0,40.88,73.5v86.28a21.38,21.38,0,0,0,21.36,21.36h72v41.5a5.21,5.21,0,0,0,9.15,3.42l38.91-44.92h11.43a21.38,21.38,0,0,0,21.36-21.36V73.5A21.39,21.39,0,0,0,193.76,52.14ZM204.7,159.78a11,11,0,0,1-10.94,10.94H180.19a5.18,5.18,0,0,0-4.18,1.79l-31.32,36.16V175.93a5.21,5.21,0,0,0-5.21-5.21H62.24A11,11,0,0,1,51.3,159.78V73.5A11,11,0,0,1,62.24,62.57H193.76A10.94,10.94,0,0,1,204.69,73.5v86.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.37,86.53H69.63a5.21,5.21,0,1,0,0,10.42H186.37a5.21,5.21,0,1,0,0-10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.37,111.43H69.63a5.21,5.21,0,0,0,0,10.42H186.37a5.21,5.21,0,1,0,0-10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.89,136.33H69.63a5.22,5.22,0,0,0,0,10.43h55.26a5.22,5.22,0,0,0,0-10.43Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventMessageWhite);
export default __webpack_public_path__ + "static/media/icon_event_message_white.cd98d4a83fe0e685e323bdaadee14baf.svg";
export { ForwardRef as ReactComponent };